<template>
  <path
    d="M19 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018ZM16 13.0002H8C7.45 13.0002 7 12.5502 7 12.0002C7 11.4502 7.45 11.0002 8 11.0002H16C16.55 11.0002 17 11.4502 17 12.0002C17 12.5502 16.55 13.0002 16 13.0002Z"
  />
</template>
